export default __webpack_public_path__ + "static/media/watermark_high.848f9bfe.png";